import { useCallback } from 'react';

/**
 * Returns a callback ref for <video> elements that forces muted-autoplay to
 * work on mobile browsers.
 *
 * React's `muted` JSX attribute doesn't reliably set the underlying DOM
 * `muted` property, so mobile Safari/Chrome treat the video as "has sound",
 * block autoplay, and leave a blank hero. This forces the property and kicks
 * off playback (retrying once the data loads for slower connections).
 *
 * The same callback can be attached to multiple videos.
 */
export default function useAutoplayVideo() {
    return useCallback((v) => {
        if (!v) return;
        v.muted = true;
        v.defaultMuted = true;
        const tryPlay = () => {
            const p = v.play();
            if (p && typeof p.catch === 'function') p.catch(() => { });
        };
        tryPlay();
        v.addEventListener('loadeddata', tryPlay);
    }, []);
}
